// ✅ ใหม่ — เรียงหมวดหมู่สินค้าตามลำดับที่ร้านตั้ง (field order) — ชุดเดียวกับ backend utils/productCategoryOrder.js
// ลำดับนี้ใช้ทั้งหน้าร้านปกติ, เมนูสั่งหน้าร้าน (dine-in) และแดชบอร์ด
// เรียง: order น้อยไปมาก (ไม่มี order = ท้ายสุด) → createdAt เก่าไปใหม่ → ชื่อ
export function sortProductCategories(list) {
  const num = (v) => (v !== null && v !== "" && Number.isFinite(Number(v)) ? Number(v) : Infinity);
  return [...(list || [])].sort((a, b) =>
    num(a.order) - num(b.order)
    || num(a.createdAt) - num(b.createdAt)
    || String(a.name || "").localeCompare(String(b.name || ""), "th")
  );
}
